import { render } from "./HeaderMain.vue?vue&type=template&id=5760a775&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=5760a775&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5760a775"

export default script